import { mapState } from 'vuex';
import { kebabCaseToCamelCase } from '../../utils/vuex';
import debounce from 'lodash/debounce';
import { templateLocals } from '../../utils/emailTemplateVariables';
import ApiService from '../../services/apiService';
export default {
  name: 'SettingsEmailTemplate',
  props: {
    id: {
      type: String,
      default: '',
      required: true
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    subject: {
      type: String,
      default: '',
      required: true
    },
    body: {
      type: String,
      default: '',
      required: true
    },
    varsSubject: {
      type: Array,
      default: () => []
    },
    varsBody: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      internalSubject: this.subject,
      internalBody: this.body,
      errorSubject: false,
      errorBody: false,
      isEmpty: false,
      showPreviewDialog: false,
      borderColor: this.color,
      previewSubject: '',
      previewBody: ''
    };
  },
  computed: {
    ...mapState('app', ['image', 'color', 'inpOutlined', 'inpFilled', 'UiTheme']),
    inputTemplateStyle() {
      return ['font-family: monospace;', 'font-weight: 500;', 'font-size: 14px;', 'line-height: 1.5em;', 'white-space: pre-wrap;', 'tab-size: 2;', '-webkit-tab-size: 2;', '-moz-tab-size: 2;', '-o-tab-size: 2;;'].join(' ');
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    internalBody: debounce(function () {
      this.checkTemplateState();
      this.renderTemplate();
    }, 200),
    internalSubject: debounce(function () {
      this.checkTemplateState();
      this.renderTemplate();
    }, 200),
    subject() {
      this.internalSubject = this.subject;
    },
    body() {
      this.internalBody = this.body;
    }
  },
  methods: {
    renderTemplate() {
      return ApiService.renderEmailTemplate(this.internalSubject, this.internalBody, templateLocals).then(data => {
        this.errorSubject = data.errors.errorSubject ? data.errors.errorSubject : false;
        this.errorBody = data.errors.errorBody ? data.errors.errorBody : false;
        return {
          subject: data.subject,
          body: data.body
        };
      });
    },
    handleShowSubjectError() {
      this.previewSubject = this.$i18n_t('accMgmt.system.errorTemplateRender');
      this.previewBody = `<pre>${this.errorSubject}</pre>`;
      this.showPreviewDialog = true;
    },
    handleShowBodyError() {
      this.previewSubject = this.$i18n_t('accMgmt.system.errorTemplateRender');
      this.previewBody = `<pre>${this.errorBody}</pre>`;
      this.showPreviewDialog = true;
    },
    handlePreview() {
      this.renderTemplate().then(result => {
        const {
          subject,
          body
        } = result;
        const error = this.errorSubject || this.errorBody;
        if (error) {
          this.previewSubject = this.$i18n_t('accMgmt.system.errorTemplateRender');
          this.previewBody = `<pre>${error}</pre>`;
        } else {
          this.previewSubject = subject;
          this.previewBody = body;
        }
        this.showPreviewDialog = true;
      }).catch(error => {
        console.error(error);
      });
    },
    checkTemplateState() {
      this.isEmpty = !this.internalBody || !this.internalSubject;
    },
    getTemplateTitle(key) {
      return this.$i18n_t(`accMgmt.system.email.templateNames.${kebabCaseToCamelCase(key)}`);
    },
    getVariableName(key) {
      return this.$i18n_t(`accMgmt.system.email.templateVariables.${key}`);
    },
    updateSubject(content) {
      this.$emit('update', this.id, 'subject', content);
    },
    updateBody(content) {
      this.$emit('update', this.id, 'body', content);
    },
    handleTemplateKeydown(e) {
      if (e.key === 'Tab' || e.keyCode === 9) {
        e.preventDefault();
        const el = e.target;
        const selectionStart = el.selectionStart;
        const selectionEnd = el.selectionEnd;
        const indentation = '\t';
        this.internalBody = `${el.value.slice(0, selectionStart)}${indentation}${el.value.slice(selectionEnd)}`;
        this.$nextTick(() => {
          el.setSelectionRange(selectionStart + indentation.length, selectionStart + indentation.length);
        });
      }
    }
  }
};